import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Trans } from "@lingui/react/macro";

interface HighlightBannerProps {
  title?: string;
  subtitle?: string;
  imageUrl?: string;
  tag?: string;
  onView?: () => void;
}

export function HighlightBanner({
  title,
  subtitle,
  imageUrl,
  tag,
  onView,
}: HighlightBannerProps) {
  return (
    <div className="relative flex h-55 items-end overflow-hidden rounded-xl bg-linear-to-r from-(--gray-800) to-(--gray-700)">
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
      )}
      <div className="absolute inset-0 bg-linear-to-t from-black/70 via-black/20 to-transparent" />
      <div className="relative z-10 flex w-full items-end justify-between p-6">
        <div className="space-y-1.5">
          {tag && (
            <span className="inline-flex items-center rounded-full bg-(--color-warning)/90 px-2.5 py-0.5 text-xs font-medium text-(--brand-white)">
              {tag}
            </span>
          )}
          {subtitle && !tag && (
            <p className="text-xs font-medium uppercase tracking-wide text-white/60">
              {subtitle}
            </p>
          )}
          {title && (
            <h2 className="text-xl font-semibold text-white">{title}</h2>
          )}
        </div>
        <Button variant="secondary" className="gap-1.5 shadow-sm shrink-0" onClick={onView}>
          <Trans>View Recipe</Trans>
          <ArrowRight className="size-4" />
        </Button>
      </div>
    </div>
  );
}
